"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _InternationalPhoneNumberInput = _interopRequireDefault(require("../../components/international-phone-number-input/InternationalPhoneNumberInput"));
var _phoneNumberInternational = _interopRequireDefault(require("../validation/phoneNumberInternational"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var formValidationIntPhoneNumberMinLength = "The number you've entered is too short";
var formValidationIntPhoneNumberInvalid = 'Please enter a valid phone number';
var INTERNATIONAL_PHONE_NUMBER = {
  component: _InternationalPhoneNumberInput["default"],
  id: 'phoneNumber',
  name: 'phoneNumber',
  type: 'tel',
  label: 'Phone number',
  required: true,
  maxLength: 20,
  validationMessageKeys: {
    required: 'Please enter a phone number',
    minLength: formValidationIntPhoneNumberMinLength,
    minLengthInt: formValidationIntPhoneNumberMinLength,
    maxLength: "The number you've entered is too long",
    regex: formValidationIntPhoneNumberInvalid,
    invalid: 'Please enter a valid phone number for ${country}',
    invalidUnknown: formValidationIntPhoneNumberInvalid
  },
  validationFnc: _phoneNumberInternational["default"],
  validationFncExtraArgsValueKeys: ['phoneNumberCountryCode']
};
var _default = exports["default"] = INTERNATIONAL_PHONE_NUMBER;